import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ExploreGoa.css';
import { weddingConfig } from '../config/weddingConfig';

const ExploreGoa = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const content = weddingConfig.content.exploreGoa;

  return (
    <div className="explore-goa-container">
      <div className="container">
        <button
          className="back-button"
          onClick={() => navigate('/')}
          style={{
            fontFamily: weddingConfig.design.fonts.body,
            color: weddingConfig.design.colors.primary,
            borderColor: weddingConfig.design.colors.primary
          }}
        >
          ← Back
        </button>
        <h1 className="page-title" style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary }}>
          {content.title}
        </h1>
        <div className="page-content" style={{ fontFamily: weddingConfig.design.fonts.body, color: weddingConfig.design.colors.secondary }}>
          <p>{content.intro}</p>

          {/* About Goa */}
          <div className="about-goa-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              About Goa
            </h2>
            <p style={{ marginBottom: '20px' }}>
              Goa, located on India's western coast, is a former Portuguese colony known for its stunning beaches, vibrant culture, and rich history. This coastal paradise blends Portuguese and Indian influences, creating a unique atmosphere with historic churches, colorful markets, and a laid-back beach culture. The region's tropical climate and natural beauty make it a popular destination for travelers seeking both relaxation and adventure.
            </p>
            <p style={{ marginBottom: '20px' }}>
              Please note that Goa experiences its monsoon season during July, which means you can expect periodic rainfall during your visit. To ensure you're comfortable and can fully enjoy all the activities, we recommend bringing the following items:
            </p>
            <ul className="rain-essentials-list">
              <li>Umbrella</li>
              <li>Rain jacket</li>
              <li>Appropriate footwear</li>
            </ul>
          </div>

          {/* Things to Do */}
          <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '50px', marginBottom: '30px', textAlign: 'center', fontSize: '1.8em' }}>
            Things to Do
          </h2>

          {/* Within 1 Hour Drive */}
          <div className="distance-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              {content.sections.nearby.title}
            </h2>
            <p className="section-description" style={{ fontStyle: 'italic', marginBottom: '20px', color: weddingConfig.design.colors.secondary }}>
              {content.sections.nearby.description}
            </p>
            <div className="place-item">
              {content.sections.nearby.items.map((place, index) => (
                <p key={index}>
                  <strong>{place.name}:</strong> {place.description}
                </p>
              ))}
            </div>
          </div>

          {/* 1 to 2 Hour Drive */}
          <div className="distance-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              {content.sections.moderate.title}
            </h2>
            <p className="section-description" style={{ fontStyle: 'italic', marginBottom: '20px', color: weddingConfig.design.colors.secondary }}>
              {content.sections.moderate.description}
            </p>
            <div className="place-item">
              {content.sections.moderate.items.map((place, index) => (
                <p key={index}>
                  <strong>{place.name}:</strong> {place.description}
                </p>
              ))}
            </div>
          </div>

          {/* Over 2 Hour Drive */}
          <div className="distance-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              {content.sections.extended.title}
            </h2>
            <p className="section-description" style={{ fontStyle: 'italic', marginBottom: '20px', color: weddingConfig.design.colors.secondary }}>
              {content.sections.extended.description}
            </p>
            <div className="place-item">
              {content.sections.extended.items.map((place, index) => (
                <p key={index}>
                  <strong>{place.name}:</strong> {place.description}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreGoa;
